import { useEffect, useState } from 'react';
import * as helpers from "../utils/utils.js"
import { useClientId } from "../context/context.js";
import { useLocation } from "react-router-dom";

const apiBaseUrl = process.env.REACT_APP_API_URL;

export function usePayment() {
    const [squareCredentials, setSquareCredentials] = useState(null);
    const [squareCredentialsIsLoading, setSquareCredentialsIsLoading] = useState(true);
    const [squareCredentialsError, setSquareCredentialsError] = useState("");

    const clientId = useClientId();

    useEffect(() => {
        let isMounted = true;

        const fetchCredentials = async () => {
            setSquareCredentialsIsLoading(true);
            setSquareCredentialsError("");

            const response = await helpers.get(`/clients/${clientId}/credentials/public/square`);

            if (!isMounted) return;

            if (
                response.success &&
                response.status === 200 &&
                response.data?.app_id &&
                response.data?.location_id
            ) {
                setSquareCredentials(response.data);
            } else {
                setSquareCredentials(null);
                setSquareCredentialsError("Secure payment settings could not be loaded.");
            }

            setSquareCredentialsIsLoading(false);
        };

        fetchCredentials();

        return () => {
            isMounted = false;
        };
    }, [clientId]);  // This effect runs once when the component is mounted.

    const createPayment = async (token, amount, slotIds) => {
        let amountPaid = 0;
        let paymentInfo = {};
    
        const data = {
          token: token,
          amount: amount,
          slots: slotIds,
        };

        const checkResponse = await helpers.post(`/clients/${clientId}/date-slots/check?status=available`, slotIds)
        
        if (checkResponse.data.confirmed !== "true") {
            return { amountPaid, paymentInfo, error: "one or more slots are no longer available" };
        }
    
        const response = await helpers.post(
          `/clients/${clientId}/make-payment`,
          data,
        );

    
        if (response.success && response.data?.payment?.status === "COMPLETED") {
            const payment = response.data.payment;
            const tempPayment = {
                status: "COMPLETED",
                receipt_number: payment.receiptNumber,
                payment_date:
                    payment.cardDetails?.cardPaymentTimeline?.capturedAt,
                last_4: payment.cardDetails?.card?.last4,
                payment_id: payment.id,
            };

            amountPaid = amount / 100;
            paymentInfo = { type: "card", ...tempPayment };
        }

        return { amountPaid, paymentInfo };
    };

    function startSquarePOSPayment(amountCents, notes, customerId) {
        var dataParameter = {

            state: notes,

            amount_money: {
                amount: String(amountCents),
                currency_code: "USD"
            },

            // Replace this value with your application's callback URL
            callback_url: `${apiBaseUrl}/clients/${clientId}/bookings/poscallback`,

            // Replace this value with your application's ID
            client_id: "sq0idp-VpYsz2dTjXrSX66na_uXHg", // boatorch app_id
            // client_id: squareCredentials.app_id,

            version: "1.3",
            notes: notes,
            options: {
                supported_tender_types: ["CREDIT_CARD","CASH","OTHER","SQUARE_GIFT_CARD","CARD_ON_FILE"]
            },

            // Link the sale to this Square customer so receipts and any
            // "save card on file" attach to the right profile. Only included
            // when we have an id (Square requires a live lookup when set).
            ...(customerId && { customer_id: customerId }),
        };

        window.location =
            "square-commerce-v1://payment/create?data=" +
            encodeURIComponent(JSON.stringify(dataParameter));
          
    }
      
      
    return {
        squareCredentials,
        squareCredentialsIsLoading,
        squareCredentialsError,
        createPayment,
        startSquarePOSPayment,
    };
}
